import React, { Component } from "react";
import PropTypes from "prop-types";
import LightBoxContent from "./LightBoxContent";
import DataContainer from "components/utility/data-container/DataContainer";

class LightBox extends Component {
	render() {
		return (
			<DataContainer data={"lightbox_" + this.props.dataset.guid}>
				<LightBoxContent />
			</DataContainer>
		);
	}
}

LightBox.propTypes = {
	dataset: PropTypes.shape({
		guid: PropTypes.string.isRequired
	})
};

export default LightBox;
